import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FC } from 'react';

import { PaymentType } from 'src/api/@generated/backend';

import { SummaryInformationCard } from 'src/components/summary-information-card';
import { SummaryInformationRow, SummaryInformationRowProps } from 'src/components/summary-information-row';
import { i18n } from 'src/i18n';
import { selectSelectedServiceLocationOrThrow, selectUserDetailsOrThrow } from 'src/state/address/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { OrderInformationUtils } from 'src/utils/order-information-utils';
import { selectSelectedProductOrThrow } from 'src/state/order/selectors';

import { StyledCreditCheck } from './payment-information.styled';

export const PaymentInformation: FC = () => {
  const user = useAppSelector(selectUserDetailsOrThrow);
  const serviceLocation = useAppSelector(selectSelectedServiceLocationOrThrow);
  const product = useAppSelector(selectSelectedProductOrThrow);
  const { pricing } = product;

  const renderPaymentInformation = () => {
    const paymentInformation: SummaryInformationRowProps[] = [
      {
        label: i18n.page.summary.paymentInformation.payee,
        value: OrderInformationUtils.getFullName(user),
        isValueSensitive: true,
      },
      {
        label: i18n.page.summary.paymentInformation.billingAddress,
        value: OrderInformationUtils.getShortAddress(serviceLocation),
        isValueSensitive: true,
      },
      {
        label: i18n.page.summary.paymentInformation.method,
        value: i18n.page.summary.paymentInformation.chosenMethod,
        note:
          pricing.paymentType === PaymentType.INSTALLMENT_INTEREST_FREE
            ? {
                label: i18n.page.summary.paymentInformation.methodDescription,
              }
            : undefined,
      },
    ];

    return (
      <>
        <div>
          {paymentInformation.map((item, index) => (
            <SummaryInformationRow key={index} {...item} />
          ))}
        </div>
        {pricing.creditCheckNeeded && (
          <StyledCreditCheck component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET} italic={true}>
            {i18n.page.summary.paymentInformation.creditCheck}
          </StyledCreditCheck>
        )}
      </>
    );
  };

  return (
    <SummaryInformationCard title={i18n.page.summary.paymentInformation.title} content={renderPaymentInformation()} />
  );
};
